
































































import Vue from 'vue'
import Component from 'vue-class-component'
import { IProduct } from './model/ProductsState';


@Component({})
export default class App extends Vue{
  public drawer = true;
  public snackbar = false;
  public snackbarMsg = "";

  logout(){
    this.$store.dispatch("user/logout");
    this.$router.push({path: '/login'})
  }

  get loggedIn() {
    return this.$store.getters['user/getLogedinStatus']
  }

  get products() {
    return this.$store.getters['products/getAllProducts']
  }

  get isLoading() {
    return this.$store.state.core.isLoading;
  }

  beforeCreate () {
    /*if(!this.loggedIn){
      this.$store.dispatch("user/logout");
    }*/
  }

  created () {
    if(this.loggedIn){
      this.$store.dispatch("products/loadAllProducts");
    }

    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'snackbar/showSnackbar') {
        this.snackbarMsg = this.$store.getters["snackbar/getSnackbarInfo"]
        this.snackbar = true
      }
    })
  }
}
